import React from "react";
//#region redux
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store";
import { ThunkDispatch } from "redux-thunk";
import { hideEULA } from "store/actions/authActions";
//#endregion
//#region types
import { ActionButton } from "models/propTypes/commonPropTypes";
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { PageFooter } from "components/common";
import { useUserService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const EULAFooter: React.FC = (props) => {
  const userService = useUserService();
  const canSuspendEula = useSelector((state: AppState) => state.auth.loggedInUser.canSuspendEula);
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const onAccept = () => {
    return userService.signEula().then(() => dispatch(hideEULA()));
  };

  const onSuspend = () => {
    return userService.suspendEulaSigning().then(() => dispatch(hideEULA()));
  };

  const getActions = () => {
    let actions: ActionButton[] = [];
    actions = [
      {
        text: TranslationKeys.Eula.Suspend,
        onClick: onSuspend,
        isDisabled: !canSuspendEula,
        secondary: true,
      },
      {
        text: TranslationKeys.Eula.AcceptUserAgreement,
        onClick: onAccept,
        type: StyleEnums.DisplayType.Success,
      },
    ];

    return actions;
  };

  return <PageFooter actions={getActions()} className={cssExports.eulaFooter} allowForReadOnlyUsers />;
};

export default EULAFooter;
